import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiPaymentMutationRequest,
  PostApiPaymentMutationResponse,
  PostApiPayment401,
  PostApiPayment403,
} from "../../../types/PostApiPayment";

export function getPostApiPaymentUrl() {
  return `/api/Payment` as const;
}

/**
 * {@link /api/Payment}
 */
export async function postApiPayment(
  data?: PostApiPaymentMutationRequest,
  config: Partial<RequestConfig<PostApiPaymentMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiPaymentMutationResponse,
    ResponseErrorConfig<PostApiPayment401 | PostApiPayment403>,
    PostApiPaymentMutationRequest
  >({
    method: "POST",
    url: getPostApiPaymentUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
